/**
 * Who must sign in with a second factor. Administrators of an organisation and Vename operators
 * always: one stolen password would expose every mailbox they manage. Other members choose, unless
 * their organisation requires it for everyone (`policy.mfaAllMembers`, off by default).
 */
export const MFA_ROLES: readonly string[] = ['owner', 'admin', 'operator'];

export function mfaAllMembers(policy: unknown): boolean {
  return typeof policy === 'object' && policy !== null && (policy as any).mfaAllMembers === true;
}

export function mfaRequired(role: string, policy: unknown): boolean {
  return MFA_ROLES.includes(role) || mfaAllMembers(policy);
}
